import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import 'intersection-observer';
import { InView } from 'react-intersection-observer';
import CompareCheckbox from '../CompareCheckbox/CompareCheckbox';
import ProductChannelsAvailability from '../ProductChannelsAvailability/ProductChannelsAvailability';
import {
  showFlexibleCreditTooltip,
  hideFlexibleCreditTooltip
} from '../../reduck/listingPageCommonData.reduck';
import { ProductBriefDescription } from '../ProductBriefDescription/ProductBriefDescription';
import ProductBriefDescriptionSwitch from '../ProductBriefDescriptonSwitch/ProductBriefDescriptionSwitch';
import AddedValueMessagesListing from '../AddedValueMessages/AddedValueMessagesListing.js';

import { getTranslation } from '../../translations/translations';
import ListItemStickerImage from './ListItemStickerImage/ListItemStickerImage';
import ProductItemTitle from '../ProductItemTitle/ProductItemTitle';
import ListItemImageAndBadges from './ListItemImageAndBadges/ListItemImageAndBadges';
import ListItemCountdownLabel from './ListItemCountdownLabel/ListItemCountdownLabel';
import ListItemPromoMessages from './ListItemPromoMessages/ListItemPromoMessages';
import ListItemOutfitsInfo from './ListItemOutfitsInfo/ListItemOutfitsInfo';
import ProductItemDescriptionBullets from '../ProductItemDescriptionBullets/ProductItemDescriptionBullets';
import ProductItemReviewInfo from '../ProductItemReviewInfo/ProductItemReviewInfo';
import ProductItemPriceBlock from '../ProductItemPriceBlock/ProductItemPriceBlock';
import ProductItemOnlineCreditInfo from '../ProductItemOnlineCreditInfo/ProductItemOnlineCreditInfo';
import SponsoredProductBeacon from '../SponsoredProductBeacon/SponsoredProductBeacon';
import { Product } from '../Product/Product';
import openFMOPopup from '../../fmoPopupOpener/fmoPopupOpener';


const TRESHOLDS = [0.5, 0.75, 1];

const PProductListItem = styled(Product)`
  display: flex;
  flex-flow: row wrap;
  padding: 10px;
  margin-top: -1px;
  z-index: 1;
  transition: border 0.2s ease;
  border: 1px solid #ccc;

  @media ${({ theme }) => theme.breakpoints.mobileMin} {
    overflow: visible;
    padding: 20px;
  }

  @media ${({ theme }) => theme.breakpoints.desktop} {
    padding-left: 20px;
  }

  .product .badges {
    display: inline-block;
  }

  &:hover {
    border-color: #4855a0;
  }

  &.hero-product {
    margin-top: 20px;
  }

  &.sponsored {
    padding: 0 0 20px;
    border: 1px solid #999;
    z-index: 2;

    &.hero-product {
      border: 1px solid #4855a0;
    }

    &:hover {
      border: 1px solid #4855a0;
    }

    .sticker {
      top: 25px;
    }

    .label-expert {
      top: 2px;
      left: 5px;
      text-align: left;
      > div {
        background-color: #f1f1f1;
        border-radius: 5px;
      }
    }

    .sponsoredLabel {
      width: 100%;
      padding-top: 2px;
      padding-bottom: 2px;
      margin-bottom: 10px;
      text-align: center;
      font-size: 13px;
      background-color: #f1f1f1;
      border-bottom: 1px solid #e5e5e5;
    }

    .productWrapper {
      padding-left: 20px;

      @media ${({ theme }) => theme.breakpoints.mobile} {
        padding-left: 10px;
      }
    }
    .productPrices {
      padding-right: 20px;

      @media ${({ theme }) => theme.breakpoints.mobile} {
        padding: 0 10px;
      }
    }

  }
  
  .sticker {
    display: inline-block;
    position: absolute;
    left: 0px;
    top: 0px;
    margin-bottom: 0;
  }

  .productWrapper {
    box-sizing: content-box;
    flex: 1;
    @media ${({ theme }) => theme.breakpoints.tablet} {
      max-width: calc(100% - 218px);
    }
    @media ${({ theme }) => theme.breakpoints.mobile} {
      flex-basis: 100%;
      width: 100%;
    }
    @media ${({ theme }) => theme.breakpoints.mobileMin} {
      max-width: calc(100% - 240px);
    }
  }

  .productListContainer {
    display: flex;
    flex-wrap: wrap;
  }


  .imgC {
    @media ${({ theme }) => theme.breakpoints.mobile} {
      width: 150px;

      img {
        max-width: 100%;
      }
    }
  }


  .desc > a {
    display: inline-block;
    width: 100%;

    [data-component='tariff-info'] {
      width: 12em;
      @media ${({ theme }) => theme.breakpoints.mobile} and (orientation: portrait) {
        margin: auto;
      }
    }

    &:hover {
      .rad {
        color: inherit;
      }
    }
  }

  .desc {
    flex-basis: 100%;
    overflow: hidden;
    min-height: 9rem;
    color: inherit;
    text-decoration: none;
    @media ${({ theme }) => theme.breakpoints.mobileMin} {
      flex: 1;
    }

    &:before {
      display: none;
    }


    a,
    .in {
      margin-bottom: 20px;
      text-align: center;
      @media ${({ theme }) => theme.breakpoints.mobileMin} {
        margin-bottom: 0;
        text-align: left;
      }
    }

    .in .brand {
      margin-bottom: 10px;
      font-weight: normal;
    }

    .in .rad {
      @media ${({ theme }) => theme.breakpoints.mobile} {
        text-align: center;
      }
    }

  }

  .rad {
    color: #000;

    i {
      font-size: 18px;
    }
  }


  .productPrices {
    /* float: left; */
    /* width: auto !important; */
    /* width: 100%; */
    /* position: relative; */
    /* background: red; */

    .amounts {
      margin-bottom: 10px;
    }

    @media ${({ theme }) => theme.breakpoints.mobileMin} {
      flex: 1;
      /* flex-basis: 209px; */
      /* max-width: 209px; */
      padding-left: 30px;
      box-sizing: content-box;
    }
    @media ${({ theme }) => theme.breakpoints.mobile} {
      /* flex-basis: 198px; */
      /* max-width: 198px; */
      padding: 0;
    }
  }

  .reevoo-placeholder {
    @media ${({ theme }) => theme.breakpoints.mobile} {
      text-align: center;
    }

    .reevoo-score {
      height: 17px;
      margin-top: 0;
      line-height: 1;
    }
  }

  .badges {
    display: inline-block;
    vertical-align: middle;
    overflow: hidden;
    margin: 0;

    @media ${({ theme }) => theme.breakpoints.mobileMin} {
      width: 100%;
      vertical-align: bottom;
      margin: 0 0 0.3em;
    }

    @media ${({ theme }) => theme.breakpoints.mobile} {
      padding-left: 5.575%;

      a {
        margin: 0 0 10px 0;
        display: block;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    img {
      display: inline-block;
      vertical-align: middle;
    }

    &.bottom-indent {
      padding-bottom: 20px;
    }
  }

  .productAdditional {
    clear: left;
    overflow: hidden;
  }

  .pack {
    display: inline-block;
    padding: 7px;
    font-size: 0.92em;
    @media ${({ theme }) => theme.breakpoints.mobile} {
      border-right: 2px solid #fff;
      border-left: 2px solid #fff;
    }
  }

  .product-desc,
  .product-desc a {
    color: #4855a0;
    margin-left: 0;
    font-size: 13px;
  }

  .dc-checkbox {
    margin-right: 5px;
  }

  .dc-checkbox-wrapper {
    padding-left: 20px;
    padding-right: 20px;
  }

  .amounts .main-amount {
    padding-top: 10px;
    padding-bottom: 10px;
  }



  .productDescription {
    overflow: hidden;
    font-size: 0.92em;
  }

  .badges {
    display: inline-block;
    top: 8em;
    left: 0;

    a {
      margin: 2px 2px;
    }

    .sticker {
      position: absolute;
      top: 0 !important;
    }
  }

  .longDescControler {
    float: left;
    clear: both;
    margin-top: 5px;
    margin-bottom: 0;
  }

  .productLongDesc {
    background: #fff;
    clear: both;

    a {
      padding: 5px;
      display: block;
      width: auto;
    }
  }

  .productDesc {
    display: none;
  }

  .productDescription {
    overflow: hidden;
    font-size: 0.92em;
  }

  .badges {
    display: inline-block;
    top: 8em;
    left: 0;

    a {
      margin: 2px 2px;
    }

    .sticker {
      position: absolute;
      top: 0 !important;
    }
  }

  .longDescControler {
    float: left;
    clear: both;
    margin-top: 5px;
    margin-bottom: 0;
  }

  .productLongDesc {
    background: #fff;
    clear: both;

    a {
      padding: 5px;
      display: block;
      width: auto;
    }
  }

  // .productAdditional .moreInfo {
  //   display: none;
  // }

  .productDesc {
    display: none;
  }

`;

const ProductWrapper = styled.div`
  box-sizing: content-box;
  flex: 1;
  @media only screen and (min-width: 600px) and (max-width: 800px) {
    max-width: calc(100% - 218px);
  }
  @media ${({ theme }) => theme.breakpoints.mobile} {
    flex-basis: 100%;
    width: 100%;
  }
  @media ${({ theme }) => theme.breakpoints.mobileMin} {
    max-width: calc(100% - 240px);
  }

  .sponsored & {
    padding-left: 20px;

    @media ${({ theme }) => theme.breakpoints.mobile} {
      padding-left: 10px;
    }
  }
`;

const OnlineCreditMessageWrapper = styled.div`
  position: relative;
`;

const LabelExpert = styled.strong`
  .hero-product {
    & {
      border: 1px solid #4855a0;
      top: -9px;
      left: -5px;
      right: -5px;
      height: auto;
      width: 100%;
      background: none;
      text-align: center;
      position: absolute;

      div {
        padding-left: 5px;
        padding-right: 5px;
        display: inline-block;
        color: #4855a0;
        background: white;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  .sponsored {
    & {
      top: 2px;
      left: 5px;
      text-align: left;
      & > div {
        background-color: #f1f1f1;
        border-radius: 5px;
      }
    }
  }
`;

const ProductListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  a {
    text-decoration: none;
  }
`;

const ProductPrices = styled.div`
  .amounts {
    margin-bottom: 10px;
  }

  @media ${({ theme }) => theme.breakpoints.mobile} {
    margin-left: 0;
    max-width: inherit;
    width: 100%;
    padding: 0 10px;
  }

  @media ${({ theme }) => theme.breakpoints.mobileMin} {
    flex: 1;
    flex-basis: 209px;
    padding-left: 30px;
    max-width: 209px;
    box-sizing: content-box;
  }

  @media only screen and (min-width: 600px) and (max-width: 800px) {
    /* flex-basis: 198px; */
    /* max-width: 198px; */
    padding-left: 20px;
  }

  .sponsored & {
    padding-right: 20px;

    @media ${({ theme }) => theme.breakpoints.mobile} {
      padding: 0 10px;
    }
  }
`;

const SponsoredLabel = styled.div`
  .sponsored & {
    width: 100%;
    padding-top: 2px;
    padding-bottom: 2px;
    margin-bottom: 10px;
    text-align: center;
    font-size: 13px;
    background-color: #f1f1f1;
    border-bottom: 1px solid #e5e5e5;
  }
`;


const DivWrapper = styled.div` 
  a {
    display: inline-block;
    vertical-align: middle;
  }

  .bundle {
    padding-left: 10px;
    padding-bottom: 20px;
    position: relative;

    .productPrices {
      float: left;
    }

    .offerSaving,
    .sticker {
      margin-top: -10px !important;
      right: auto !important;
    }
  }

  .stamped {
    .offerSaving {
      border-radius: 0 5.8em 5.8em;
      color: #fff;
      font-family: Gotham, Arial, sans-serif;
      line-height: 1;
      padding: 5px;
      width: 59px;
      height: 59px;
      z-index: 1;
      box-shadow: 1px 1px 2px rgba(black, 0.2);
      background: #1e249e;
      background: linear-gradient(to bottom right, #213a7b 0%, #682670 100%);
    }
  }

  .obProduct {
    .offerSaving {
      position: relative;
      top: 0.5em;
      left: auto;
      right: 15px;
      white-space: nowrap;

      &:before {
        bottom: auto;
        top: -0.45em;
        left: 85%;
        border-top: 0;
        border-bottom: 0.5em solid #5b2a72;
      }
    }
  }

  .product {
    position: relative;

    .desc {
      .offerSaving {
        text-align: left;
        float: right;
        display: block;
        position: relative;
      }
    }

    .product-images {
      .sticker {
        top: -0.5em !important;
      }
    }

    .count {
      display: inline-block;
      margin-left: 0.5em;
    }
  }

  .obProduct {
    .offerSaving {
      right: 0;
    }
  }

  .imgC {
    text-decoration: none;
    @media ${({ theme }) => theme.breakpoints.desktop} {
      text-decoration: none;
    }
  }

  .productLink {
    position: static;
  }

  .compare-checkbox {
    margin-top: 20px;
  }

  > .list-on-load-beacon {
    position: absolute;
    top: 0;
    left: 0;
  }

  > article:first-child {
    margin-top: 0;
  }

  .product-desc .product-desc-toggle-closed {
    padding-bottom: 0;
  }

  .clickableArea {
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: -1;
  }

  &.hero-product {
    overflow: visible;

    .label-expert {
      top: -9px;
      left: -5px;
      right: -5px;
      height: auto;
      width: 100%;
      background: none;
      text-align: center;
      position: absolute;

      div {
        padding-left: 5px;
        padding-right: 5px;
        display: inline-block;
        color: #4855a0;
        background: white;
        margin-left: auto;
        margin-right: auto;
      }
    }

    .resultList & {
      border: 1px solid #4855a0;
    }
  }

  .sponsored .product {
    margin: 0;
    padding: 0 0 20px;
  }
`;

class ProductListItem extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      onView: null
    };
  }

  getSupportedOnlineCreditSpecialOfferType(stickerImage) {
    if (stickerImage?.alt?.match(/bnpl/gi)) {
      // product supports 'buy now and pay later' special credit offer type
      return 'BNPL';
    }

    if (stickerImage?.alt?.match(/ifc/gi)) {
      // product supports 'interest free credit' special credit offer type
      return 'IFC';
    }

    // product supports no special credit offer type
    return undefined;
  }

  renderProductContent() {
    const {
      defaultChannelsAvailability,
      hasOurExpertsLoveTag,
      sponsored,
      stickerImage,
      loadImagesLazily,
      link,
      isFMOProduct,
      brand,
      title,
      icons,
      image,
      displayCompare,
      isFlashSale,
      countdownClassSuffix,
      id,
      comboKitItemsNames,
      review,
      price,
      comboKitNumberOfItemsMessage,
      descriptionBullets,
      promoMessages,
      preOrder,
      isOnlineCreditAvailable,
      placeSpecificChannelsAvailability,
      deviceType,
      priceForOnlineCredit,
      openedCreditTooltipProductID,
      showCreditTooltip,
      hideCreditTooltip,
      briefDescriptionProductID,
      descriptionShortened
    } = this.props;

    const supportedOnlineCreditSpecialOfferType = this.getSupportedOnlineCreditSpecialOfferType(
      stickerImage
    );

    return (
      <>
        <LabelExpert className={'label-expert'}>
          <div>{hasOurExpertsLoveTag ? getTranslation('ourExpertsLoveTranslation') : ' '}</div>
        </LabelExpert>
        {
          sponsored && (
            <SponsoredLabel className={'sponsoredLabel'}>Sponsored</SponsoredLabel>
          ) /* Add to translations */
        }
        {stickerImage && (
          <ListItemStickerImage stickerImage={stickerImage} loadImagesLazily={loadImagesLazily} />
        )}
        <ProductWrapper className={'productWrapper'}>
          <ProductItemTitle
            brand={brand}
            title={title}
            link={link}
            onClick={(e) => {
              if (isFMOProduct) {
                e.preventDefault();
                e.stopPropagation();

                openFMOPopup(link);
              }
            }}
          />
          <ProductListContainer className={'productListContainer'}>
            <ListItemImageAndBadges
              image={image}
              link={link}
              icons={icons}
              loadImagesLazily={loadImagesLazily}
              onClick={(e) => {
                if (isFMOProduct) {
                  e.preventDefault();
                  e.stopPropagation();

                  openFMOPopup(link);
                }
              }}
            />
            <div className={'desc'}>
              <a
                href={link}
                onClick={(e) => {
                  if (isFMOProduct) {
                    e.preventDefault();
                    e.stopPropagation();

                    openFMOPopup(link);
                  }
                }}
              >
                <div className={'in'}>
                  {isFlashSale && (
                    <ListItemCountdownLabel countdownClassSuffix={countdownClassSuffix} id={id} />
                  )}
                  <ListItemPromoMessages
                    promoMessages={promoMessages}
                    loadImagesLazily={loadImagesLazily}
                    preOrder={preOrder}
                  />
                  {comboKitItemsNames && (
                    <ListItemOutfitsInfo
                      comboKitItemsNames={comboKitItemsNames}
                      comboKitNumberOfItemsMessage={comboKitNumberOfItemsMessage}
                    />
                  )}
                  {!comboKitItemsNames && descriptionBullets.length > 0 && (
                    <ProductItemDescriptionBullets descriptionBullets={descriptionBullets} />
                  )}
                  {promoMessages.dealsAvailable && (
                    <AddedValueMessagesListing view={'list'} data={promoMessages.dealsAvailable} />
                  )}
                  {review && <ProductItemReviewInfo review={review} />}
                </div>
              </a>
              <ProductBriefDescriptionSwitch productID={id} />
            </div>
          </ProductListContainer>
        </ProductWrapper>
        <ProductPrices className={'productPrices'}>
          <ProductItemPriceBlock
            defaultChannelsAvailability={defaultChannelsAvailability}
            price={price}
            isFlashSale={isFlashSale}
            variant={'listing_list'}
            displayWasPriceRange
          />

          {isOnlineCreditAvailable && (
            <OnlineCreditMessageWrapper className={'online-credit-message-wrapper'}>
              <ProductItemOnlineCreditInfo
                productID={id}
                specialCreditOfferType={supportedOnlineCreditSpecialOfferType}
                productPriceWithoutCurrencySign={priceForOnlineCredit}
                deviceType={deviceType}
                openedCreditTooltipProductID={openedCreditTooltipProductID}
                showCreditTooltip={showCreditTooltip}
                hideCreditTooltip={hideCreditTooltip}
              />
            </OnlineCreditMessageWrapper>
          )}
          <ProductChannelsAvailability
            defaultChannelsAvailability={defaultChannelsAvailability}
            placeSpecificChannelsAvailability={placeSpecificChannelsAvailability}
            id={id}
          />
          {!!deviceType && displayCompare && (
            <CompareCheckbox productId={id} tooltipArrowDirection={'bottom'} />
          )}
        </ProductPrices>
        {briefDescriptionProductID === id && (
          <ProductBriefDescription
            icons={icons}
            descriptionShortened={descriptionShortened}
            link={link}
            isFMOProduct={isFMOProduct}
            productDescriptionLinkTranslation={getTranslation('productDescriptionLinkTranslation')}
          />
        )}
      </>
    );
  }

  render() {
    const {
      displayCompare,
      stickerImage,
      hasOurExpertsLoveTag,
      comboKitItemsNames,
      defaultChannelsAvailability,
      sponsored,
      beacons,
      id,
      dataInteraction
    } = this.props;

    // 'product',
    const classes = ['result-prd', 'clearfix'];

    if (displayCompare) {
      classes.push('productCompare');
    }

    if (stickerImage) {
      classes.push('stamped');
    }

    if (hasOurExpertsLoveTag) {
      classes.push('hero-product');
    }

    if (comboKitItemsNames) {
      classes.push('obProduct');
    }

    if (defaultChannelsAvailability.canBeDownloaded) {
      classes.push('download');
    }

    if (sponsored) {
      classes.push('sponsored');
    }

    return (

      <DivWrapper>
        {
      sponsored && beacons?.onView ? (
      // when product is sponsored we need to add beacon img element when user have the product in view on his display
        <InView
          as={'article'}
          onChange={(inView, entry) => {
            if (inView) {
              this.setState({
                onView: beacons.onView
              });
            }
          }}
          threshold={TRESHOLDS}
          triggerOnce
          id={`product${id}-hooklogic`}
          className={classes.join(' ')}
          data-interaction={dataInteraction}
          data-fupid={dataInteraction ? id : undefined}
        >
          <PProductListItem className={'product'}>
            {this.renderProductContent()}
            {this.state.onView ? (
              <SponsoredProductBeacon
                className={'sponsored-product-beacon'}
                src={this.state.onView}
                alt={'beacon'}
              />
            ) : null}
          </PProductListItem>
        </InView>
      ) : (
        <article
          id={`product${id}`}
          className={classes.join(' ')}
          data-interaction={dataInteraction}
          data-fupid={dataInteraction ? id : undefined}
        >
          <PProductListItem className={'product'}>
            {this.renderProductContent()}
          </PProductListItem>
        </article>

      )
      }

      </DivWrapper>
    );
  }
}

ProductListItem.displayName = 'ProductListItem';

ProductListItem.propTypes = {
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      imgUrl: PropTypes.string.isRequired,
      linkUrl: PropTypes.string
    })
  ),
  briefDescriptionProductID: PropTypes.string,
  defaultChannelsAvailability: PropTypes.shape({
    canBeDownloaded: PropTypes.bool,
    showEmailMeBack: PropTypes.bool,
    delivery: PropTypes.shape({
      type: PropTypes.string
    }),
    inStore: PropTypes.shape({
      type: PropTypes.string
    })
  }).isRequired,
  placeSpecificChannelsAvailability: PropTypes.shape({
    canBeDownloaded: PropTypes.bool,
    showEmailMeBack: PropTypes.bool,
    delivery: PropTypes.shape({
      type: PropTypes.string
    }),
    inStore: PropTypes.shape({
      type: PropTypes.string
    })
  }),
  comboKitItemsNames: PropTypes.arrayOf(PropTypes.string),
  comboKitNumberOfItemsMessage: PropTypes.string,
  countdownClassSuffix: PropTypes.string,
  displayCompare: PropTypes.bool.isRequired,
  deviceType: PropTypes.string,
  hasOurExpertsLoveTag: PropTypes.bool.isRequired,
  isFlashSale: PropTypes.bool.isRequired,
  isOnlineCreditAvailable: PropTypes.bool,
  priceForOnlineCredit: PropTypes.number,
  brand: PropTypes.shape({
    title: PropTypes.string.isRequired
  }).isRequired,
  descriptionShortened: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.shape({
    currentPrice: PropTypes.string.isRequired,
    savingsPrice: PropTypes.string,
    wasPrice: PropTypes.string,
    wasPriceFrom: PropTypes.string,
    wasPriceTo: PropTypes.string
  }).isRequired,
  link: PropTypes.string.isRequired,
  isFMOProduct: PropTypes.bool,
  promoMessages: PropTypes.shape({
    dealsAvailable: PropTypes.arrayOf(PropTypes.object),
    isOnlineOnly: PropTypes.bool.isRequired,
    marketingMessages: PropTypes.arrayOf(
      PropTypes.shape({
        class: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
      }).isRequired
    ),
    numberOfDealsAvailableTranslation: PropTypes.string,
    badges: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        src: PropTypes.string.isRequired
      })
    )
  }).isRequired,
  preOrder: PropTypes.shape({
    available: PropTypes.bool.isRequired,
    message: PropTypes.string
  }).isRequired,
  descriptionBullets: PropTypes.arrayOf(PropTypes.string).isRequired,
  review: PropTypes.shape({
    reviewCount: PropTypes.number.isRequired,
    score: PropTypes.number
  }),
  stickerImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string
  }),
  loadImagesLazily: PropTypes.bool,
  openedCreditTooltipProductID: PropTypes.string,
  showCreditTooltip: PropTypes.func,
  hideCreditTooltip: PropTypes.func,
  dataInteraction: PropTypes.string,
  sponsored: PropTypes.bool,
  beacons: PropTypes.shape({
    onView: PropTypes.string
  })
};

ProductListItem.defaultProps = {
  icons: undefined,
  placeSpecificChannelsAvailability: undefined,
  comboKitItemsNames: undefined,
  comboKitNumberOfItemsMessage: undefined,
  countdownClassSuffix: undefined,
  isOnlineCreditAvailable: false,
  priceForOnlineCredit: undefined,
  deviceType: undefined,
  review: undefined,
  stickerImage: undefined,
  loadImagesLazily: false,
  briefDescriptionProductID: null,
  openedCreditTooltipProductID: null,
  showCreditTooltip: () => {},
  hideCreditTooltip: () => {},
  dataInteraction: undefined,
  sponsored: false,
  beacons: null,
  isFMOProduct: false
};

const mapStateToProps = (state) => ({
  openedCreditTooltipProductID: state.listingPage.commonData.flexibleCreditTooltipProductID,
  briefDescriptionProductID: state.listingPage.commonData.briefDescriptionProductID,
  deviceType: state.listingPage.browser ? state.listingPage.browser.device.deviceType : undefined
});

const dispatchFunctions = {
  showCreditTooltip: showFlexibleCreditTooltip,
  hideCreditTooltip: hideFlexibleCreditTooltip
};

export default connect(mapStateToProps, dispatchFunctions)(ProductListItem);
